import { utils } from 'apprise-core/utils'
import { useT } from 'apprise-frontend-core/intl/language'
import { PastModeIcon } from 'apprise-ui/field/field'
import { LabelProps } from 'apprise-ui/label/label'
import { Tip } from 'apprise-ui/tooltip/tip'
import { NamedPropertyContext } from 'apprise-ui/utils/namedproperty'
import { useContext } from 'react'



export type ChangeLabelProps<T> = LabelProps & {

    before: T | undefined
    after: T

    render?: (_: T) => React.ReactNode

}

export const ChangeLabel = <T extends any>(props: ChangeLabelProps<T>) => {

    const t = useT()

    // 'borrows' the context of NamedProperty for sheer convenience.
    const {undefinedAsEmpty, trackCase=true} = useContext(NamedPropertyContext) ?? {}

    const { before, after, render = t => (t as JSX.Element) } = props

    const $render = (t: T) => <>{render(t)}</>

    const normalize = (value: unknown) => {
        if (value == null || value === undefined) return undefined
        if (typeof value === 'string' && !trackCase) return value.toLowerCase()
        return value
    }

    const beforeNorm = normalize(before)
    const afterNorm = normalize(after)

    const showChange = (undefinedAsEmpty || beforeNorm !== undefined) && !utils().deepequals(afterNorm, beforeNorm)

    return showChange ?

        <div className='apprise-row'>
            {$render(after)}
            &nbsp;
            <Tip tip={<><span>{t('rec.change_previous')}</span>{ before != null ? $render(before) : t('rec.change_missing')}</>} >
                <PastModeIcon color='seagreen' />
            </Tip>

        </div> : $render(after)
}